import React, { useRef, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as yup from "yup";
import PreviewImage from "./PreviewImage";
import styled from "styled-components";
import { Box, Button } from "@mui/material";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { EasyToastify } from "../Extentions/EasyToastify";
import Moment from "moment";
import JsonData from "../Data/data.Url.json";
import GameId from "../Components/GameId";

const StyledModal = styled.div`
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  position: fixed;
  z-index: 10;
`;

const StyledOverlay = styled.div`
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  position: fixed;
  background: rgba(49, 49, 49, 0.8);
`;

const StyledModalContent = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #2f475d;
  padding: 24px 28px;
  border-radius: 20px;
  width: 700px;

  @media only screen and (max-width: 480px) {
    width: 380px;
  }
`;

const StyledField = styled(Field)`
  font-family: Montserrat, sans-serif;
`;

const StyledRedBox = styled(Box)`
  color: red;
`;

const StyledImg = styled.img`
  width: 144px;
  height: 81px;
  object-fit: contain;

  @media only screen and (max-width: 480px) {
    width: 40px;
    height: 24px;
  }
`;

const SUPPORTED_FORMATS = ["image/jpg", "image/jpeg", "image/png"];
const validationSchema = yup.object({
  title: yup
    .string()
    .min(5, "Too small!")
    .max(60, "Too long string")
    .required("Title is required!"),
  // gameId: yup.number().required("Game Type is required!"),
  date: yup
    .date()
    .required("Date is required"),
  shortDescription: yup
    .string()
    .min(5, "Too small!")
    .max(300, "Too long string")
    .required("Short Description is required"),
  description: yup
    .string()
    .min(20, "Too small!")
    .max(4000, "Too long string")
    .required("Description is required"),
  // videoUrl: yup
  //   .string()
  //   .nullable()
  //   .min(0)
  //   .max(40, "Too long string"),
  file: yup
    .mixed()
    .nullable()
    .required()
    .test(
      "FILE_SIZE",
      "Upload file is too big.",
      (value) => !value || (value && value.size <= 2048 * 2048)
    )
    .test(
      "FILE_FORMAT",
      "Upload file has unsupported format.",
      (value) => !value || (value && SUPPORTED_FORMATS.includes(value?.type))
    ),
});

export default function NewsModal(props) {
  const fileRef = useRef(null);
  // POST METHOD
  const [serverState, setServerState] = useState();
  const handleServerResponse = (ok, msg) => {
    setServerState({ ok, msg });
  };
  const handleOnSubmit = async (values, actions) => {
    let videoUrl = values.videoUrl.split("/").pop();
    const formData = new FormData();

    if (values.id !== "") {
      formData.append("id", values.id);
    }
    formData.append("title", values.title);
    formData.append("description", values.description);
    formData.append("shortDescription", values.shortDescription);
    formData.append("date", values.date);
    formData.append("newsType", 0);
    formData.append("GameId", selectGameId);
    formData.append("videoUrl", videoUrl);
    formData.append("image", values.file);

    await props
      .method(`/NewsMaker/${props.apiUrl}`, formData)
      .then((response) => {
        console.log(response);
        actions.setSubmitting(false);
        actions.resetForm();
        handleServerResponse(true, "");
        EasyToastify.ToastSuccess("News Added");
        props.toggleModal();
      })
      .catch((error) => {
        console.log(error);
        actions.setSubmitting(false);
        handleServerResponse(false, error.response.data.error);
        EasyToastify.ToastError("Error");
      });
  };

  const [news] = useState(
    props.news
      ? {...props.news, date: Moment(props.news.date).format("YYYY-MM-DD")}
      : {
          id: "",
          title: "",
          gameId: 1,
          date: "",
          newsType: 1,
          shortDescription: "",
          description: "",
          videoUrl: "",
          file: null,
        }
  );

  const [selectGameId, setSelectGameId] = useState(
    props.news ? props.news.gameId : 1
  );
  const handleSelectGameIdChange = (e) => {
    setSelectGameId(e.target.value);
  };

  return (
    <Box>
      {props.modal && (
        <StyledModal>
          <StyledOverlay onClick={props.toggleModal}></StyledOverlay>
          <StyledModalContent>
            <Formik
              // validateOnMount={true}
              enableReinitialize={true}
              initialValues={news}
              onSubmit={handleOnSubmit}
              validationSchema={validationSchema}
            >
              {({ values, setFieldValue }) => (
                <Form>
                  <Box display="flex" flexDirection="column">
                    <label>Title: </label>
                    <Field
                      name="title"
                      type="text"
                      placeholder={`Enter Title...`}
                    />
                    <StyledRedBox>
                      <ErrorMessage name="title" />
                    </StyledRedBox>
                  </Box>
                  <Box display="flex" flexDirection="column">
                    <label>Game Type:</label>
                    <select
                      name="gameId"
                      as="select"
                      required={true}
                      onChange={handleSelectGameIdChange}
                      defaultValue={props.news ? props.news.gameId : 1}
                    >
                      <GameId />
                    </select>
                    <StyledRedBox>
                      <ErrorMessage name="gameId" />
                    </StyledRedBox>
                  </Box>
                  <Box display="flex" flexDirection="column">
                    <label>Date:</label>
                    <Field
                      name="date"
                      type="date"
                    />
                    <StyledRedBox>
                      <ErrorMessage name="date" />
                    </StyledRedBox>
                  </Box>
                  <Box display="flex" flexDirection="column">
                    <label>Short Description:</label>
                    <Field
                      name="shortDescription"
                      as="textarea"
                      rows={5}
                      placeholder={`Enter Short Description...`}
                    />
                    <StyledRedBox>
                      <ErrorMessage name="shortDescription" />
                    </StyledRedBox>
                  </Box>
                  <Box display="flex" flexDirection="column">
                    <label>Description:</label>
                    <Field
                      name="description"
                      as="textarea"
                      cols={40}
                      rows={20}
                      placeholder={`Enter Description...`}
                    />
                    <StyledRedBox>
                      <ErrorMessage name="description" />
                    </StyledRedBox>
                  </Box>
                  <Box display="flex" flexDirection="column">
                    <label>Video Iframe url: </label>
                    <Field
                      name="videoUrl"
                      type="text"
                      placeholder={`Enter iframe url...`}
                    />
                    <StyledRedBox>
                      <ErrorMessage name="videoUrl" />
                    </StyledRedBox>
                  </Box>
                  {values.videoUrl ? (
                    <StyledImg
                      src={
                        "https://img.youtube.com/vi/" +
                        values.videoUrl.split("/").pop() +
                        "/sddefault.jpg"
                      }
                      alt={values.videoUrl}
                    />
                  ) : (
                    ""
                  )}
                  <Box display="flex" flexDirection="column" paddingTop="8px">
                    <input
                      ref={fileRef}
                      hidden
                      type="file"
                      name="file"
                      onChange={(event) => {
                        setFieldValue("file", event.target.files[0]);
                      }}
                    />
                    {values.file ? (
                      <PreviewImage
                        file={values.file}
                        width="192px"
                        height="108px"
                      />
                    ) : values.imgUrl != null ? (
                      <img
                        src={
                          JsonData.imgurl + values.imgUrl.replace("\\\\", "\\")
                        }
                        alt="Uploaded Photo"
                        style={{ width: "192px", height: "108px" }}
                      />
                    ) : (
                      ""
                    )}
                    <Button
                      variant="contained"
                      onClick={() => {
                        fileRef.current.click();
                      }}
                    >
                      Upload Photo
                    </Button>
                    <StyledRedBox>
                      <ErrorMessage name="file" />
                    </StyledRedBox>
                  </Box>
                  <Box display="flex" flexDirection="column" paddingTop="8px">
                    <Button variant="contained" type="submit">
                      Submit
                    </Button>
                  </Box>
                  {serverState && (
                    <p className={!serverState.ok ? "errorMsg" : ""}>
                      {serverState.msg}
                    </p>
                  )}
                </Form>
              )}
            </Formik>

            <Button
              variant="text"
              sx={{
                color: "red",
                position: "absolute",
                top: "3px",
                right: "5px",
              }}
              onClick={props.toggleModal}
            >
              <CancelOutlinedIcon />
            </Button>
          </StyledModalContent>
        </StyledModal>
      )}
      <ToastContainer />
    </Box>
  );
}
